import styled from "styled-components";
import LoginImage from "@src/assets/img/Photo_Login.svg";
import { device } from "@src/theme";
export const LoginWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-image: url("${LoginImage}");
  background-size: cover;
  background-position: right center;
  background-repeat: no-repeat;
  transition:
    background-image 0.2s ease-in-out,
    background-color 0.2s ease-in-out;
`;

export const FormContainer = styled.div`
  height: 100vh;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }): string => theme.colors.darkerBg};
  @media ${device.tablet} {
    width: 100%;
  }
  @media ${device.mobile} {
    width: 100%;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  max-width: 400px;
  margin: 0 auto;
  padding: 2rem;
`;

export const Title = styled.h1`
  color: ${({ theme }): string => theme.colors.yellow};
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: bold;
  text-align: center;
  width: 100%;
  display: block;
`;

export const Input = styled.input`
  border: none;
  border-bottom: 1px solid ${({ theme }): string => theme.colors.yellow};
  padding: 5px 0px;
  font-size: 1rem;
  width: 100%;
  outline: none;
  color: ${({ theme }): string => theme.colors.white};
  background-color: transparent !important;

  transition: all 0.2s ease-in-out;
  &::placeholder {
    opacity: 0.45;
    color: ${({ theme }): string => theme.colors.yellow};
    font-size: 1rem;
  }

  &:focus {
    border-bottom: 2px solid ${({ theme }): string => theme.colors.yellow};
    padding: 5px 10px;
  }
`;

export const InputLabel = styled.label`
  margin-top: 2rem;
  font-size: 1rem;
  width: 100%;
  display: block;
  font-weight: bold;
  color: ${({ theme }): string => theme.colors.yellow};
`;
export const ResetPasswordButton = styled.button`
  background-color: transparent;
  color: ${({ theme }): string => theme.colors.yellow};
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  align-self: flex-start;
  text-align: flex-start;
  padding-left: 0;
  font-size: 0.8rem;
  text-decoration: underline;
  margin-bottom: 1rem;
`;

export const Button = styled.button`
  background-color: ${({ theme }): string => theme.colors.yellow};
  color: ${({ theme }): string => theme.colors.darkerBg};
  font-size: 1rem;
  padding: 0.5rem 1rem;
  margin-top: 2rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: 80%;
`;

export const LoginLogo = styled.img`
  width: 100%;
  max-width: 150px;
  height: auto;
`;
export const LeftContainer = styled.div`
  ::selection {
    background: ${({ theme }) => theme.colors.opacity_yellow};
  }
  height: 100vh;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${device.tablet} {
    display: none;
  }
  @media ${device.mobile} {
    display: none;
  }
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 80%;
  margin: 0 auto;
  padding: 2rem;
`;
export const Heading1 = styled.h1`
  font-family: "Kern Standard";
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  color: ${({ theme }): string => theme.colors.yellow};
`;
export const Heading2 = styled.h2`
  font-family: "Kern Standard";
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  color: ${({ theme }): string => theme.colors.yellow};
  margin-top: 0.8rem;
`;
